import {Action} from "../actions/pagesActions";
import {ActionType} from "../actionTypes";
import {SelectPageForTabsDto} from "../../dtos";


export class SelectPageForTabsState implements SelectPageForTabsDto {
    pageNo = 0;
    selectedTabNum = 0;
}

const initialState = new SelectPageForTabsState();

const selectPageForTabsReducer = (state: SelectPageForTabsState = initialState, action: Action) => {

    switch(action.type)
    {
        case ActionType.SET_SELECTED_PAGE_FOR_TABS:
            return {
                pageNo: action.payload.pageNo,
                selectedTabNum: action.payload.selectedTabNum
            };
        default:
            return state;
    }
}

export default selectPageForTabsReducer;